import { Component, OnInit, Input, OnChanges, OnDestroy } from '@angular/core'
import { CheckoutService } from '../../checkout.service'
import { Observable, Subscription } from 'rxjs'
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms'
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core'
import { ViewChild } from '@angular/core'
import { ElementRef } from '@angular/core'
import { ActiveCartFacade } from '@spartacus/cart/base/root'
import { OrderType } from '../../../../../../models/status/status.model'
import { QuoteCheckoutService } from '../../../../../quote/quote-checkout/services/quote-checkout.service'
import { QuoteDataService } from '../../../../../quote/quote-checkout/services/quote-data.service'

@Component({
  standalone: false,
  selector: 'vs-customer-detail',
  templateUrl: './customer-detail.component.html',
  styleUrls: ['./customer-detail.component.scss'],
})
export class CustomerDetailComponent implements OnInit, OnChanges, OnDestroy {
  @Input() isProceedToCheckout: boolean
  @ViewChild('endUseIndustryError', { read: ElementRef, static: false })
  public endUseIndustryError: ElementRef
  @ViewChild('endCustomerAddressNotSelectedError', {
    read: ElementRef,
    static: false,
  })
  public endCustomerAddressNotSelectedError: ElementRef

  public hideForm: boolean
  public custDetail: boolean
  public radioSelected: string
  public newAdd: boolean
  public term: string
  public name
  public selectedAddress
  public hideBtn: boolean
  orderType: any = ''
  public nuclearCheck = 'Power - Nuclear'
  cart
  cartName = 'vscart'
  getEndUserArray: any
  getEndIndustryLen
  endUserSelected: any
  activeCart: any
  userType: string
  public checkNuclear: boolean = false
  legalEntityData$: Observable<any>
  legalEntityData: any
  myGroupEnd: FormGroup
  componentAddress = 'End Customer'
  isSelectAddress = false
  endUserCountry: any
  selectedAddressEdit: any

  userAddressData: any
  userAddressData$: Observable<any>
  cartId: any
  endUserIndustryName: any
  endCustomerAddress: any
  retainEndUserIndustry = null
  customerDetailsObj: any
  orderTypeEnum = OrderType
  activeCartSubscription: Subscription

  constructor(
    private checkoutService: CheckoutService,
    private quoteCheckoutService: QuoteCheckoutService,
    private formBuilder: FormBuilder,
    private data: QuoteDataService,
    protected activeCartService: ActiveCartFacade,
    private globalMessageService: GlobalMessageService
  ) {
    this.newAdd = false
    this.custDetail = true
    this.hideForm = false
    this.name = ''
    this.selectedAddress = null
    this.hideBtn = true
    this.userType = 'current'
    this.checkoutService.getEndCustomerAddData.subscribe((address) => {
      this.selectedAddress = address
    })
    this.activeCartSubscription = this.activeCartService
      .getActiveCartId()
      .subscribe(
        (cartId) => {
          if (cartId) {
            this.cartId = cartId

            this.checkoutService.getCartServerResponse.subscribe(
              (success) => {
                this.cart = success
                if (this.cart?.quoteCartType) {
                  this.myGroupEnd?.controls['endUseIndustry'].disable()
                }

                if (
                  this.cart?.rfqType?.toLowerCase() ===
                    this.orderTypeEnum.STOCK.toLowerCase() ||
                  (!this.cart?.billToAddress &&
                    this.cart?.rfqType?.toLowerCase() !==
                      this.orderTypeEnum.RESALE.toLowerCase())
                ) {
                  this.selectedAddress = this.cart?.billToAddress
                  this.endUserCountry =
                    this.cart?.billToAddress?.country?.isocode
                  this.hideBtn = false
                  this.checkoutService.endCustomerAddressData.next(
                    this.selectedAddress
                  )
                } else {
                  this.selectedAddress = this.cart?.endUserAddress
                  this.hideBtn = true
                  this.checkoutService.endCustomerAddressData.next(
                    this.selectedAddress
                  )
                }
                if (
                  this.selectedAddressEdit &&
                  this.cart?.rfqType?.toLowerCase() !==
                    this.orderTypeEnum.STOCK.toLowerCase()
                ) {
                  this.selectedAddress = this.selectedAddressEdit
                  this.hideBtn = true
                  this.checkoutService.endCustomerAddressData.next(
                    this.selectedAddress
                  )
                } else {
                  this.selectedAddress = (this.cart?.rfqType?.toLowerCase() == this.orderTypeEnum.RESALE.toLowerCase()) ? this.cart?.endUserAddress : this.cart?.billToAddress;
                  this.hideBtn = (this.cart?.rfqType?.toLowerCase() == this.orderTypeEnum.RESALE.toLowerCase()) ? true : false;
                  this.checkoutService.endCustomerAddressData.next(
                    this.selectedAddress
                  )
                }
              },
              (error) => {
                // this.globalMessageService.add(
                //   error,
                //   GlobalMessageType.MSG_TYPE_ERROR,
                //   5000
                // );
                // window.scrollTo(0, 0);
              }
            )
          }
        },
        (error) => {
          // this.globalMessageService.add(
          //   error,
          //   GlobalMessageType.MSG_TYPE_ERROR,
          //   5000
          // );
          // window.scrollTo(0, 0);
        }
      )

    this.myGroupEnd = this.formBuilder.group({
      endUseIndustry: new FormControl('', Validators.required),
    })
  }

  ngOnDestroy(): void {
    if (this.activeCartSubscription) {
      this.activeCartSubscription.unsubscribe()
    }
  }

  ngOnChanges(changes) {
    if (
      this.cart?.rfqType?.toLowerCase() ===
        this.orderTypeEnum.STOCK.toLowerCase() ||
      (!this.cart?.endUserAddress &&
        this.cart?.rfqType?.toLowerCase() !==
          this.orderTypeEnum.RESALE.toLowerCase())
    ) {
      this.selectedAddress = this.checkoutService.endCustomerAddressData.getValue()
    }
  }

  ngOnInit(): void {
    this.getEndUserIndustry()
    this.getUserAddress()
    this.checkoutService.orderpreferences.subscribe(
      (data) => {
        this.customerDetailsObj = data
        if (this.customerDetailsObj.endUserIndustry) {
          this.checkoutService.sendCustomerDataForm(true)
        }
        if(this.cart.cartOrderType && this.cart.cartOrderType?.code != 'STK'){
         this.myGroupEnd.controls['endUseIndustry'].setValue(
            this.customerDetailsObj.endUserIndustryCode
          ) 
        }
        
        this.getEndUserArray?.forEach((element) => {
          if (element.code == this.customerDetailsObj.endUserIndustryCode) {
            this.onEndUserSelect(element.code)
          }
        })

        this.selectedAddressEdit = this.customerDetailsObj.endUserAddress
      },
      (error) => {
        // this.globalMessageService.add(
        //   error,
        //   GlobalMessageType.MSG_TYPE_ERROR,
        //   5000
        // );
        // window.scrollTo(0, 0);
      }
    )

    this.myGroupEnd.valueChanges.subscribe(
      (data) => {
        if (this.cart?.quoteCartType) {
          this.checkoutService.sendCustomerDataForm(true)
        } else {
          this.checkoutService.sendCustomerDataForm(this.myGroupEnd.valid)
        }
      },
      (error) => {
        // this.globalMessageService.add(
        //   error,
        //   GlobalMessageType.MSG_TYPE_ERROR,
        //   5000
        // );
        // window.scrollTo(0, 0);
      }
    )

    this.checkoutService.endCustomerAddressData.subscribe((data) => {
      if (
        this.cart?.rfqType?.toLowerCase() ===
          this.orderTypeEnum.STOCK.toLowerCase() ||
        (!this.cart?.billToAddress &&
          this.cart?.rfqType?.toLowerCase() !==
            this.orderTypeEnum.RESALE.toLowerCase())
      ) {
        this.selectedAddress = data
      }
      // this.selectedAddress = data;
    })
  }

  proceedToReview() {
    if (this.myGroupEnd.invalid) {
      return
    }
  }
  addAddress() {
    this.newAdd = true
  }

  closeForm(event) {
    this.isSelectAddress = event
  }

  nameAdd(event) {
    this.name = event.firstName + ' ' + event.lastName
    this.hideForm = false
  }

  getEndUserIndustry() {
    this.checkoutService.getEndUserIndustry(this.cartId).subscribe(
      (success) => {
        if(this.cart.cartOrderType && this.cart.cartOrderType?.code == 'RSL'){
          this.getEndUserArray = success['endUserIndustries'].filter(item => item.value.toLowerCase() !== 'stock'); 
        } else if(this.cart.cartOrderType && this.cart.cartOrderType?.code == 'STK'){
          this.getEndUserArray = success['endUserIndustries'].filter(item => item.value.toLowerCase() === 'stock');
          this.myGroupEnd.get('endUseIndustry').setValue(this.getEndUserArray?.[0]?.code);
          this.myGroupEnd.get('endUseIndustry').disable();
          this.checkoutService.sendCustomerDataForm(true);
          this.onEndUserSelect(this.getEndUserArray?.[0]?.code);
        } else{
          this.getEndUserArray = success['endUserIndustries'];
        }
      },
      (error) => {
        // this.globalMessageService.add(
        //   error,
        //   GlobalMessageType.MSG_TYPE_ERROR,
        //   5000
        // );
        // window.scrollTo(0, 0);
      }
    )
  }

  onEndUserSelect(value: any) {
    this.captureData(value)

    this.getEndIndustryLen = this.getEndUserArray.length

    this.checkoutService.sendCustomerDataForm(true)
    for (let i = 0; i < this.getEndIndustryLen; i++) {
      if (
        this.myGroupEnd.controls['endUseIndustry'].value ===
        this.getEndUserArray[5].code
      ) {
        this.checkNuclear = true
      } else {
        this.checkNuclear = false
      }
    }
    this.checkoutService.sendNuclear(this.checkNuclear)
  }

  captureData(value: any) {
    this.checkoutService.endUserIndustryData.next(value)
  }

  selectedAdd(event) {
    this.selectedAddress = event
    this.data.sendLoggedinShipToAddress(this.selectedAddress)
    this.checkoutService.endCustomerAddressData.next(this.selectedAddress)
    this.endUserCountry = this.selectedAddress.country.isocode
    this.closeForm(false)
  }

  getUserAddress() {}

  selectAddress() {
    this.isSelectAddress = true
  }
  closeAdd(flag) {
    this.isSelectAddress = flag
  }

  get formControls() {
    return this.myGroupEnd.controls
  }

  get endUseIndustry() {
    return this.myGroupEnd.get('endUseIndustry')
  }
}
